import { render } from "./GlobalLoader.vue?vue&type=template&id=67c5d31b&scoped=true"
import script from "./GlobalLoader.vue?vue&type=script&lang=js"
export * from "./GlobalLoader.vue?vue&type=script&lang=js"

import "./GlobalLoader.vue?vue&type=style&index=0&id=67c5d31b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c5d31b"]])

export default __exports__